import { affiliationEmailValidator } from './affiliation-email.validator';
import { arrayNoMatchValidator } from './array-no-match.validator';
import { combinedStringsLengthValidator } from './combined-strings-length.validator';
import { dateComparitorValidator } from './date-comparitor.validator';
import { emailFormatValidator } from './email-format.validator';
import { factorPoints } from './factor-points.validator';
import { singleFileExtensionValidator } from './files/file-extension.validator';
import { fileSizeTotalValidator } from './files/file-size-total.validator';
import { fileSizeValidator } from './files/file-size.validator';
import { fileTypeValidator } from './files/file-type.validator';
import { allOrNone } from './form/all-or-none.validator';
import { atLeastOne } from './form/at-least-one.validator';
import { numericOrder } from './form/numeric-order.validator';
import { imageRatioValidator } from './image-ratio.validator';
import { lessThanOrEqualToValidator } from './less-than-equal-to.validator';
import { mixedCharactersValidator } from './mixed-characters.validator';
import { moduloValidator } from './modulo.validator';
import { numericValidator } from './numeric.validator';
import { passwordMatchValidator } from './password-match.validator';
import { stringExclusionValidator } from './password-name-and-login-exclusions.validator';
import { stringExclusionFormValidator } from './password-name-and-login-form-exclusions.validator';
import { singleByteValidator } from './single-byte.validator';
import { singleStringExclusiveExclusionValidator } from './single-string-exclusive-exclusion.validator';
import { spacesOnly } from './spaces-only.validator';
import { tripleSequentialCharactersValidator } from './triple-sequential-characters.validator';
import { uniqueInValidator } from './unique-from.validator';
import { urlValidator } from './url.validator';
import {
	vuePostalCodeValidator,
	vueUsaCanadaPhoneFormatValidator,
	vueZerosPhoneFormatValidator,
} from './vue';

// TODO:BLG Organize these into subfolders

export class CmValidators {
	// single field validators
	public static mixedCharacters = mixedCharactersValidator();
	public static stringExclusionValidator = stringExclusionValidator;
	public static singleStringExclusiveExclusionValidator = singleStringExclusiveExclusionValidator;
	public static factorPointsValidator = factorPoints;
	public static moduloValidator = moduloValidator;
	public static tripleSequentialCharacters = tripleSequentialCharactersValidator();
	public static spacesOnly = spacesOnly();
	public static emailFormat = emailFormatValidator;
	/** @deprecated Use emailFormat validator in combination with Angualr's email validator */
	public static affiliationEmailRequirements = affiliationEmailValidator;
	public static urlValidator = urlValidator();
	public static fileSizeValidator = fileSizeValidator;
	public static fileSizeTotalValidator = fileSizeTotalValidator;
	public static fileTypeValidator = fileTypeValidator;
	public static singleFileExtensionValidator = singleFileExtensionValidator;
	public static imageRatioValidator = imageRatioValidator;
	public static uniqueInValidator = uniqueInValidator;
	public static numeric = numericValidator;
	public static vuePostalCode = vuePostalCodeValidator;
	public static vueUsaPhoneFormat = vueUsaCanadaPhoneFormatValidator();
	public static vueZerosPhoneFormat = vueZerosPhoneFormatValidator();
	public static singleByte = singleByteValidator();

	// form array validators
	public static arrayNoMatchValidator = arrayNoMatchValidator;
	// form validators
	public static allOrNone = allOrNone;
	public static atLeastOne = atLeastOne;
	public static dateComparitor = dateComparitorValidator;
	public static lessThanOrEqualToValidator = lessThanOrEqualToValidator;
	public static numericOrder = numericOrder;
	public static passwordMatch = passwordMatchValidator;
	public static combinedStringsLengthValidator = combinedStringsLengthValidator;
	public static stringExclusionFormValidator = stringExclusionFormValidator;
}
